import styled from 'styled-components';
import { mediaMinWidth } from '@lux/templates';
import { Text, Preset, BrandColor, FunctionColor } from '@lux/text';
export const NavigationWrapper = styled.button.withConfig({ displayName: "NavigationWrapper", componentId: "sc-12m7ryg" }) `width:50px;display:flex;flex-direction:column;justify-content:center;align-items:center;align-content:center;cursor:pointer;position:relative;text-decoration:none;border:none;background-color:transparent;margin:0;padding:0;color:${FunctionColor.function100};${mediaMinWidth.sm}{width:70px;}`;
export const NavigationIcon = styled.span.withConfig({ displayName: "NavigationIcon", componentId: "sc-1pb8ojv" }) `flex:0 0 auto;position:relative;svg{transition:fill 0.4s ease;}`;
export const NavigationLabel = styled(Text)
    .withConfig({
    shouldForwardProp: prop => !['hover', 'forceLabelVisibility'].includes(prop), // fix for styled components passing the props down
})
    .attrs(() => ({
    preset: Preset.XS,
})) `
    && {
        position: absolute;
        bottom: 4px;
        left: 0;
        width: 100%;
        text-align: center;
        line-height: 1.2;
        color: ${FunctionColor.function100};
        transition: color 0.4s ease;
        display: ${({ forceLabelVisibility }) => (forceLabelVisibility ? 'block' : 'none')};

        ${NavigationWrapper}:hover &,
        ${NavigationWrapper}[aria-expanded="true"] & {
            color: ${BrandColor.primary};
        }

        ${mediaMinWidth.sm} {
            position: static;
            padding-top: 5px;
            display: block;
            flex: 0 0 auto;
        }

        & > span[role="timer"] {
            color: ${BrandColor.primary};
        }
    }
`;
export const Notification = styled(Text).withConfig({ displayName: "Notification", componentId: "sc-10l3r5b" }) `&&{position:absolute;top:-3px;right:-3px;text-align:center;border-radius:50%;background-color:${BrandColor.primary};color:${FunctionColor.function0};line-height:14px;min-width:14px;height:14px;}`;
export const NavigationItemAriaLabel = styled.span.withConfig({ displayName: "NavigationItemAriaLabel", componentId: "sc-8pvpoy" }) `display:none;`;
export const IconWrapper = styled.span.withConfig({ displayName: "IconWrapper", componentId: "sc-166gaav" }) `& > svg{fill:${FunctionColor.function100};}${NavigationWrapper}:hover && > svg,${NavigationWrapper}[aria-expanded="true"] && > svg{fill:${BrandColor.primary};}`;
//# sourceMappingURL=styles.js.map